module.exports = "/assets/2Yh5ukSQjQ.svg";